<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-transit-transfer
      </v-icon> Activities
    </h2>
    <br>
    <v-tabs
      v-model="tab"
      color="#FF3700"
      background-color="#ECEFF1"
    >
      <v-tab
        v-for="item in items"
        :key="item.tab"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="tab"
      class="my-tabs-background-style"
      touchless
    >
      <v-tab-item
        v-for="item in items"
        :key="item.tab"
      >
        <v-card-text>
          <component :is="item.content" />
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import AllServiceProviederActivities from 'src/views/dashboard/ServiceProviders/AllServiceProviderActivities.vue';
  import RecentServiceProviderActivities from 'src/views/dashboard/ServiceProviders/RecentServiceProviderActivities.vue';

  export default {
    name: 'ServiceProviderActivities',

    components: {
      AllServiceProviederActivities,
      RecentServiceProviderActivities,
    },
    data: () => ({
      tab: null,
      items: [
        { tab: 'All', content: AllServiceProviederActivities },
        { tab: 'Recent', content: RecentServiceProviderActivities },
      ],
    }),
    computed: {
    },
    methods: {
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-tabs-background-style {
  background-color: #ECEFF1 !important;
}
#regular-tables {
  padding-right: 0px;
}
</style>
